var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLandmark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 21.7384C1.5 21.3177 1.83855 20.9768 2.25618 20.9768H21.7438C22.1614 20.9768 22.5 21.3177 22.5 21.7384C22.5 22.159 22.1614 22.5 21.7438 22.5H2.25618C1.83856 22.5 1.5 22.159 1.5 21.7384Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 18.6919C3 18.2713 3.33855 17.9303 3.75618 17.9303H20.2438C20.6614 17.9303 21 18.2713 21 18.6919C21 19.1125 20.6614 19.4535 20.2438 19.4535H3.75618C3.33855 19.4535 3 19.1125 3 18.6919Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 10.4137H6V14.946H4.5V10.4137Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M9 10.4137H10.5V14.946H9V10.4137Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 10.4137H15V14.946H13.5V10.4137Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M18 10.4137H19.5V14.946H18V10.4137Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 14.946H19.5V15.7014C19.5 16.1186 19.1642 16.4568 18.75 16.4568H5.25C4.83579 16.4568 4.5 16.1186 4.5 15.7014V14.946Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5639 10.4527C21.8557 10.4527 21.9757 10.0724 21.7382 9.90012L12.4359 1.64186C12.1751 1.45271 11.8248 1.45271 11.5641 1.64186L2.26176 9.90012C2.02427 10.0724 2.14428 10.4527 2.43613 10.4527H21.5639ZM18.75 9.05396L12 3.01079L5.24999 9.05396H18.75Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLandmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/landmark.8055ee26a939d9eecd92a7d5ec6ff126.svg";